import wixSite from 'wix-site';
import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
	}
})

async function refreshAlbumData({albumData, sets}) {
	const {styleParams: {allowSocial, allowDownload}} = albumData;
	allowSocial ? $w('#share').show() : $w('#share').hide();
	allowDownload ? $w('#download').show() : $w('#download').hide();
}
